import api from "../utils/axiosConfig";

type PlayerApiUser = {
  id: string;
  username: string;
};

type PlayerLoginApiResponse = {
  token: string;
  user: PlayerApiUser;
};

export type LoginParams = {
  username: string;
  password: string;
};

export type LoginResponse = {
  user_id: string;
  name: string;
  phone_no: string;
  token: string;
};

export type LoginApiResponse = {
  status: number;
  system: string;
  message: string;
  data: LoginResponse;
};

export const postLogin = async (
  params: LoginParams
): Promise<LoginApiResponse> => {
  const response = await api.post<PlayerLoginApiResponse>("/auth/login", params);
  return {
    status: 1,
    system: "auth",
    message: "Login successful",
    data: {
      user_id: response.data.user.id,
      name: response.data.user.username,
      phone_no: "",
      token: response.data.token,
    },
  };
};
